const headers = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

export default {
  API_URL: process.env.VUE_APP_API_URL
    || `https://${process.env.VUE_APP_USE_PROD_API === 'true' ? 'app' : 'staging'}.resprohealthandsafety.com/api/v1_0`,
  HEADERS: headers,
  TIMEOUT: 5000, // Milliseconds
  ACCOUNT_TYPE: "Login", // "Google" for Google Account sign-ins
  GOOGLE_CLIENT_ID: process.env.NODE_ENV !== "production" ? "" : "",
};
